import { defineComponent } from 'vue';
import { setupComponent } from '@studyportals/vue-platform';
import Popup from './Popup.CB';

export default defineComponent({
	emits: ['showOverview'],
	setup: (props, { emit }) => {
		const codeBehind = new Popup(emit);

		return setupComponent(codeBehind);
	},
});
